export default {
  article: {
    title: 'USFans Spreadsheet: La guía completa y el centro de recursos',
    quickAnswerLabel: 'Respuesta rápida',
    quickAnswer: 'El USFans Spreadsheet es un recurso único y organizado que agrupa la mercancía y ropa de fanáticos estadounidenses en categorías claras. En lugar de abrir docenas de pestañas o adivinar dónde buscar, puedes ir directamente a zapatos, sudaderas, camisetas deportivas y accesorios a través de enlaces directos, ahorrando tiempo y manteniendo tu navegación ordenada.',
    intro: 'Ya sea que busques una camiseta deportiva específica, explores zapatillas nuevas o simplemente tengas curiosidad por lo que está disponible, el USFans Spreadsheet está diseñado para facilitar el descubrimiento. Esta guía explica qué es el spreadsheet, qué puedes encontrar dentro, cómo usarlo y por qué es un punto de partida útil para fanáticos y compradores.',
    secWhat: {
      title: '¿Qué es el USFans Spreadsheet?',
      p1: 'El USFans Spreadsheet es un directorio seleccionado y basado en categorías de mercancía con temática estadounidense. Organiza los tipos de productos más populares — desde calzado y sombreros hasta accesorios y fragancias — en una estructura sencilla y navegable. En lugar de una lista larga y desestructurada, el spreadsheet usa agrupaciones claras para que siempre sepas dónde buscar.',
      p2: 'Piénsalo como un único punto de entrada. Cada categoría tiene su propio enlace directo, lo que significa que puedes pasar de la página de inicio a una colección enfocada en un clic. El objetivo es reducir la fricción y ayudarte a encontrar lo que quieres más rápido.',
    },
    secFind: {
      title: 'Qué puedes encontrar dentro',
      p1: 'El spreadsheet cubre una amplia gama de categorías de ropa y accesorios, incluyendo:',
    },
    secHow: {
      title: 'Cómo usar el USFans Spreadsheet',
      p1: 'Usar el spreadsheet es sencillo. En la página de inicio, elige una categoría del menú desplegable o toca cualquier tarjeta de categoría. Serás llevado directamente a la colección correspondiente en el sitio principal. Como cada categoría tiene un enlace directo y dedicado, te saltas el habitual ir y venir de buscar y filtrar.',
      p2: 'Para la experiencia más rápida, comienza con el menú desplegable cuando sepas exactamente lo que quieres, y usa la cuadrícula cuando prefieras explorar visualmente.',
    },
    secPopular: {
      title: 'Categorías populares para explorar',
      p1: 'Algunas categorías son especialmente populares entre los visitantes. El calzado es un punto de partida frecuente para los fanáticos de las zapatillas, mientras que las sudaderas y suéteres siguen siendo una opción ideal para el uso diario y cómodo. Las camisetas deportivas atraen a los aficionados al deporte, y los accesorios — desde bolsos hasta cinturones — ofrecen formas rápidas de completar un atuendo.',
      p2: 'También vale la pena explorar perfumes y conjuntos si buscas ideas de regalo o un look coordinado. Cada categoría apunta a una colección dedicada, para que puedas sumergirte en el área que más te interese.',
    },
    secCompare: {
      title: 'USFans Spreadsheet vs. búsqueda manual',
      p1: 'La siguiente tabla compara el uso del USFans Spreadsheet con la búsqueda manual en varias páginas.',
      col1: 'USFans Spreadsheet',
      col2: 'Búsqueda manual',
      col3: 'Ideal para',
      r1factor: 'Organización',
      r1v1: 'Alta — categorías claras',
      r1v2: 'Varía — depende del esfuerzo',
      r1best: 'Mantener el orden',
      r2factor: 'Velocidad',
      r2v1: 'Rápido — enlaces directos',
      r2v2: 'Más lento — muchos pasos',
      r2best: 'Acceso rápido',
      r3factor: 'Consistencia',
      r3v1: 'Estructura estandarizada',
      r3v2: 'Inconsistente',
      r3best: 'Visitas repetidas',
      r4factor: 'Curva de aprendizaje',
      r4v1: 'Baja',
      r4v2: 'Moderada',
      r4best: 'Principiantes',
      r5factor: 'Actualizaciones',
      r5v1: 'Fáciles de refrescar',
      r5v2: 'Manuales',
      r5best: 'Mantenerse al día',
    },
    secTips: {
      title: 'Consejos para aprovecharlo al máximo',
      tip1: 'Comienza con la categoría que coincida con tu objetivo: buscar es más rápido cuando eres específico.',
      tip2: 'Usa el menú desplegable para saltos rápidos y la cuadrícula para explorar visualmente.',
      tip3: 'Marca la página de inicio para poder volver al recurso cuando lo necesites.',
      tip4: 'Vuelve a consultar las guías actualizadas y las nuevas categorías.',
    },
    faq: {
      title: 'Preguntas frecuentes',
      q1: '¿Qué es el USFans Spreadsheet?',
      a1: 'Es un directorio basado en categorías que organiza la mercancía y ropa de fanáticos estadounidenses en una estructura sencilla y navegable con enlaces directos a cada colección.',
      q2: '¿Es gratis explorar el spreadsheet?',
      a2: 'Sí. Explorar las categorías y leer las guías de este recurso es completamente gratis.',
      q3: '¿Cómo encuentro una categoría específica?',
      a3: 'Usa el menú desplegable de la página de inicio para ir a una categoría, o toca cualquier tarjeta de categoría en la cuadrícula.',
      q4: '¿Necesito una cuenta para usarlo?',
      a4: 'No se requiere cuenta para explorar las categorías o leer las guías.',
      q5: '¿A dónde me llevan los enlaces de categoría?',
      a5: 'Cada enlace de categoría te lleva a la colección correspondiente en nuestro sitio principal, donde puedes ver los productos de esa categoría.',
    },
    related: {
      title: 'Sigue explorando',
      text: 'Vuelve a la página de inicio para explorar todas las categorías, o visita el sitio principal directamente.',
    },
    ctaButton: 'Visitar el sitio principal',
    backHome: 'Volver al centro de USFans Spreadsheet',
    author: 'Equipo editorial de USFans',
    published: 'Publicado',
    updated: 'Actualizado',
  },
};